import { IPromoDeductionMatchSummary } from "@/core/repositories/promotion";
import { atom } from "jotai";

export interface PromoMatchDeductionState {
  summaries: IPromoDeductionMatchSummary[];
  isLoading: boolean;
  isApplying: boolean;
  error: Error | null;
}

export const promoMatchByDeductionIdAtom = atom<Record<number, PromoMatchDeductionState>>({});
